import script from "./AdminPress.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminPress.vue?vue&type=script&setup=true&lang=js"

import "./AdminPress.vue?vue&type=style&index=0&id=0cae8487&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cae8487"]])

export default __exports__